/**
 * Address Utils
 */

export function formatAddress(
  address: GQL.AddressInterface | IAddress,
  getCountryLabel: (code: string) => string | undefined,
  getStateLabel: (code: string) => string | undefined,
  printCountry?: boolean,
) {
  if (address.hasOwnProperty('subdivision_code')) {
    const gqlAddress = address as GQL.AddressInterface;

    return formatAddress({
      street: gqlAddress.line_1!,
      unit: gqlAddress.line_2 || undefined,
      city: gqlAddress.city!,
      postalCode: gqlAddress.postal_code!,
      state: gqlAddress.subdivision_code!,
      country: gqlAddress.country_code!,
      company: {
        name: gqlAddress.company!,
        type: gqlAddress.hasOwnProperty('company_type') && (gqlAddress as GQL.IOrderAddress).company_type ?
          (gqlAddress as GQL.IOrderAddress).company_type!.name!
          : '',
      },
    }, getCountryLabel, getStateLabel, printCountry);
  }

  const {
    street,
    unit,
    city,
    postalCode,
    state,
    country,
  } = address as IAddress;

  const countryName = getCountryLabel(country!);
  const stateName = getStateLabel(state!);
  const addressUnit = unit ? `, ${unit}` : ``;
  const addressState = stateName ? `, ${stateName}` : '';
  const addressCountry = countryName ? `${countryName}  ` : '';
  const addressString = `${street}${addressUnit}
    ${city}${addressState}
    ${postalCode}${printCountry ? ` ${addressCountry}` : ''}`;

  return addressString;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/utils/address.ts